<template>
  <div class="AdCate">
    <div class="cateBox">
      <p class="titleP">
        {{ $route.query.year }}年度浙江音乐学院社会艺术水平等级考试
      </p>
      <p class="titleP1">准考证</p>
      <p class="titleP2">
        <span>编号</span><span class="borderSpan">{{ userInfo.zkzbh }}</span>
      </p>
      <div class="contentBox">
        <div>
          <p>
            <span class="borderSpan2">姓名</span
            ><span class="borderSpan">{{ userInfo.name }}</span>
          </p>
          <p>
            <span class="borderSpan2">性别</span
            ><span class="borderSpan">{{ userInfo.sex }}</span>
          </p>
          <p>
            <span class="borderSpan2">出生年月</span
            ><span class="borderSpan">{{ userInfo.birth }}</span>
          </p>
          <p>
            <span class="borderSpan2">专业</span
            ><span class="borderSpan">{{ userInfo.subjectName }}</span>
          </p>
          <p>
            <span class="borderSpan2">级别</span
            ><span class="borderSpan">{{ userInfo.testLevel }}</span>
          </p>
        </div>
        <div>
          <img
            width="140px"
            :src="'data:image/png;base64,' + userInfo.photo"
            alt=""
          />
        </div>
      </div>
      <table class="contentTable">
        <tr>
          <td>成绩\项目</td>
          <td>基本练习</td>
          <td>练习曲</td>
          <td>乐曲1</td>
          <td>乐曲2</td>
          <td>音准，节奏</td>
          <td>音乐表现</td>
        </tr>
        <tr>
          <td>优秀</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>良好</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>一般</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>较差</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td class="colTd">是否通过</td>
          <td colspan="6">
            <el-checkbox-group v-model="tableChi">
              <el-checkbox value="1" label="通过"></el-checkbox>
              <el-checkbox value="2" label="不通过"></el-checkbox>
            </el-checkbox-group>
          </td>
        </tr>
        <tr>
          <td class="colTd">评语</td>
          <td colspan="6"></td>
        </tr>
      </table>

      <div class="footTitle">
        <div>注意事项：</div>
        <div>
          <p>1、提前半小时进场</p>
          <p>2、要求背谱演奏</p>
          <p>3、服从评委、工作人员安排</p>
          <p>4、评委有权中途叫停、不影响考试成绩</p>
        </div>
      </div>
      <div class="footTitle2">
        <div>浙江音乐学院</div>
        <div>社会艺术水平等级考试委员会</div>
        <!-- <div></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeCreate() {
    if (
      !this.$route.query.examId ||
      !this.$route.query.userId ||
      !this.$route.query.year
    ) {
      this.$message.warning({ message: "缺少必要参数，无法展示!",duration:1000});
      return;
    }
  },
  created() {
    this.$axios
      .get(
        `process/scanlook/${this.$route.query.examId}/${this.$route.query.userId}`
      )
      .then((res) => {
        this.userInfo = res.data.data;
      });
  },
  data() {
    return {
      userInfo: {},
      tableChi: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.AdCate {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: auto;
  .cateBox {
    position: absolute;
    width: 140vw;
    padding: 10px 10% 10% 10%;
    left: 0;
    .titleP1 {
      margin-top: 1%;
      text-align: center;
      font-size: 1.6rem;
      font-weight: bold;
    }
    .titleP {
      margin-top: 10%;
      text-align: center;
      font-size: 1.1rem;
      font-weight: bold;
    }
    .titleP2 {
      text-align: right;
    }
    span {
      line-height: 2;
    }
    .borderSpan {
      border-bottom: 1px solid #000;
      width: 140px;
      display: inline-block;
      margin-left: 10px;
      text-align: center;
    }
    .borderSpan2 {
      width: 60px;
      display: inline-block;
    }
    .contentBox {
      display: flex;
      div:first-child {
        width: 40%;
        p {
          margin-top: 6px;
        }
      }
      div:last-child {
        flex: 1;
        display: flex;
        justify-content: flex-end;
      }
    }
    .contentTable {
      margin-top: 2%;
      tr {
        td {
          text-align: center;
          border: 1px solid #f2f2f2;
          line-height: 3;
        }
      }
      .colTd {
        padding: 20px 0px;
      }
    }
    .footTitle {
      display: flex;
      margin-top: 10px;
      div:first-child {
        width: 100px;
      }
      div:last-child {
        flex: 1;
        p {
          text-align: left;
          margin-bottom: 10px;
        }
      }
    }
    .footTitle2 {
      div {
        text-align: right;
        margin-top: 10px;
      }
      div:first-child {
        padding-right: 30px;
      }
    }
  }
}
</style>
